<template>
  <Category
    cate-name="news"
    category-name="MAG2 NEWS賞"
    category-intro="総合ニュースサイト「MAG2 NEWS」で今年紹介したメルマガ記事の中から、アクセス数、SNSシェア数をもとにセレクトしました。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
